/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import crc32 from 'crc/calculators/crc32';

export class FileUtil {
    public static splitArrayBufferIntoChunks(buffer: ArrayBuffer, chunkSize: number): Uint8Array[] {
        const chunks: Uint8Array[] = [];
        let offset = 0;

        while (offset < buffer.byteLength) {
            const chunk = new Uint8Array(
                buffer,
                offset,
                Math.min(chunkSize, buffer.byteLength - offset)
            );
            chunks.push(chunk);
            offset += chunkSize;
        }

        return chunks;
    }


    // Convert CRC number to 4 byte uint8array to be appended to firmware data
    public static numberToUint8Array(num: number) {
        let data = new DataView(new ArrayBuffer(4));
        data.setUint32(0, num, true);
        return new Uint8Array(data.buffer);
    }

    public static appendBuffer(buffer1: ArrayBuffer, buffer2: ArrayBuffer) {
        const result = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
        result.set(new Uint8Array(buffer1), 0);
        result.set(new Uint8Array(buffer2), buffer1.byteLength);
        return result.buffer;
    }

    public static computeAndAppendCRC(arrayBuffer: ArrayBuffer) {
        let crc = crc32(new Uint8Array(arrayBuffer));
        console.warn(`File CRC: ${crc} : ${crc.toString(16)}`);
        let crcBuffer = FileUtil.numberToUint8Array(crc);
        return FileUtil.appendBuffer(arrayBuffer, crcBuffer.buffer);
    }
}
